var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'toggle-switch',
    {
      'toggle-switch--labeled': _vm.isLabeled,
    } ]},[(_vm.disabledLabel)?_c('span',{staticClass:"option-label"},[_vm._v(" "+_vm._s(_vm.disabledLabel)+" ")]):_vm._e(),_c('input',{attrs:{"id":_vm.id,"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.input}}),_c('label',{attrs:{"for":_vm.id}}),(_vm.enabledLabel)?_c('span',{staticClass:"option-label"},[_vm._v(" "+_vm._s(_vm.enabledLabel)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }